import type { ConversationDigestApiModel } from "@noa/api-core";
import type { AppLanguageType } from "@noa/i18n";
import { useTranslation } from "react-i18next";
import { formatConversationDate } from "../utils/date";

export function useConversationTitle(conversationSummary: ConversationDigestApiModel): {
  title: string;
  dateTitle: string;
} {
  const { t, i18n } = useTranslation("conversation");
  const dateTitle = t("conversationTitle", {
    date: formatConversationDate(conversationSummary.created_at, i18n.language as AppLanguageType),
  });

  return { title: conversationSummary.name ?? dateTitle, dateTitle };
}
